import { render, staticRenderFns } from "./HuongDanVienForm.vue?vue&type=template&id=00631918&"
import script from "./HuongDanVienForm.vue?vue&type=script&lang=js&"
export * from "./HuongDanVienForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports